import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import firebase from 'firebase/app';
import 'firebase/auth';

Vue.config.productionTip = false

console.log('Init FB');
firebase.initializeApp({
  apiKey: "AIzaSyAJFIiu4NBbcdmZGB9TNAeCFMlsTqOazUs",
  authDomain: "motiplate-3a8d1.firebaseapp.com",
  databaseURL: "https://motiplate-3a8d1.firebaseio.com",
  projectId: "motiplate-3a8d1",
  storageBucket: "motiplate-3a8d1.appspot.com",
  messagingSenderId: "428032502847",
  appId: "1:428032502847:web:e2999005027b89f5"
});

firebase.auth().onAuthStateChanged(function(user) {
  if (user) {
    store.commit('setUser', user);
  } else {
    // Logout
    console.log('Auth changed - logout')
    store.commit('setUser', null);
  }
  
  // Start the app
  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App),
    created() {
    }
  }).$mount('#app')
});

